import { Box, useMediaQuery } from "@mui/material";
import { colors, fontFamilies } from "~/theme";

interface ArtworkTokenDescriptionProps {
    artworkDescription?: string | number | boolean;
}

export function ArtworkTokenDescription({
    artworkDescription,
}: ArtworkTokenDescriptionProps) {
    const isDesktop = useMediaQuery("(min-width:1100px)");

    if (artworkDescription) {
        return (
            <Box
                data-testid="artwork-description"
                fontFamily={fontFamilies.poppins}
                fontSize={!isDesktop ? "13px" : "16px"}
                letterSpacing="0.1px"
                fontWeight={300}
                color={colors.black}
                marginTop={!isDesktop ? "24px" : "48px"}
                overflow="scroll"
                maxHeight="200px"
                sx={{
                    "&::-webkit-scrollbar": {
                        display: "none",
                    },
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                }}
            >
                {artworkDescription}
            </Box>
        );
    }

    return null;
}
